import * as React from "react";
const SvgHome24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 21,
        fill: "black",
        viewBox: "0 0 22 21"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m11 .258 10.5 7.737V20.5H13v-5a2 2 0 1 0-4 0v5H.5V7.995L11 .258ZM2.5 9.005V18.5H7v-3a4 4 0 1 1 8 0v3h4.5V9.005L11 2.742 2.5 9.005Z",
      clipRule: "evenodd"
    })
  );
export default SvgHome24Px;
